"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToolbarSplitMenuButtonWrapper = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
const ToolbarSplitMenuButtonWrapper = (0, _styled.default)("div")`
    box-sizing: border-box;
    display: flex;
    width: fit-content;
    align-items: stretch;
    max-width: 100%;
    padding: 0;
    margin: 0;
    // unsure why this line is necessary, but small size toolbar doesn't work without it
    min-height: 28px;
    height: 100%;
`;
exports.ToolbarSplitMenuButtonWrapper = ToolbarSplitMenuButtonWrapper;
//# sourceMappingURL=ToolbarSplitMenuButtonWrapper.js.map